module.exports = __webpack_public_path__ + "56f4de53f1ff7fcaeb0d8097fcb0689b.svg";